import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../Form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import StickyToolbar from "../../StickyToolbar";
import { IListarPesquisaSatisfacao } from "../../../Interfaces/HelpDesk/GestaoRespostas/GestaoRespostasInterface";
import { useModuloInfo } from "../../../Context/ModuloInfo";
import Select from "react-select";
import { useRef, useState } from "react";
import {
    ListarEmpreendimentosModuloController,
    ListarProdutosPorEmpreendimentosController,
} from "../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import useAsyncCallback from "../../../hooks/useAsyncCallback";

interface IFiltroPesquisaSatisfacao {
    FILTRO_PESQUISA_SATISFACAO_HELPDESK_ID_MODULO: string | null;
    filtroInicial: IListarPesquisaSatisfacao;
    setFilter: (filter: IListarPesquisaSatisfacao) => void;
}

export default function FiltroPesquisaSatisfacao(
    props: IFiltroPesquisaSatisfacao
) {
    const formMethods = useForm();
    const { reset } = formMethods;

    const { id } = useModuloInfo();

    const idEmpreendimentoRef = useRef<any>();
    const idUnidadeRef = useRef<any>();

    const [idEmpreendimento, setIdEmpreendimento] = useState<number[]>([]);
    const [idUnidade, setIdUnidade] = useState<number[]>([]);

    const {
        FILTRO_PESQUISA_SATISFACAO_HELPDESK_ID_MODULO,
        filtroInicial,
        setFilter,
    } = props;

    const { value: listarEmpreendimentos } = useAsyncEffect(async () => {
        if (id) return ListarEmpreendimentosModuloController(id);
    }, [id]);

    const { execute: listarUnidades, value: unidadesListadas } =
        useAsyncCallback(ListarProdutosPorEmpreendimentosController);

    function handleFilterFormSubmit(formData: IListarPesquisaSatisfacao) {
        const FormData = {
            ...formData,
            PAGINA: 1,
            QUANTIDADE: 10,
            ID_EMPREENDIMENTOS: idEmpreendimento,
            ID_UNIDADES: idUnidade,
        };
        sessionStorage.setItem(
            `FILTRO_PESQUISA_SATISFACAO_HELPDESK_${id}`,
            JSON.stringify(FormData)
        );
        setFilter(FormData);
    }

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const limparFiltros = () => {
        idEmpreendimentoRef.current?.clearValue();
        idUnidadeRef.current?.clearValue();
    };

    return (
        <StickyToolbar active={!!FILTRO_PESQUISA_SATISFACAO_HELPDESK_ID_MODULO}>
            <FormProvider {...formMethods}>
                <UnForm handleSubmit={handleFilterFormSubmit} usingContext>
                    <div className="mb-3">
                        <UnForm.Input
                            name="DT_INICIAL"
                            label="Dt. Resposta Inicial"
                            type="date"
                            registerOptions={{
                                required: "Selecione uma data inicial",
                            }}
                        />
                    </div>

                    <div className="mb-3">
                        <UnForm.Input
                            name="DT_FINAL"
                            label="Dt. Resposta Final"
                            type="date"
                            registerOptions={{
                                required: "Selecione uma data final",
                            }}
                        />
                    </div>

                    <div className="mb-3">
                        <label>Empreendimento</label>
                        <Select
                            options={listarEmpreendimentos?.map(
                                (empreendimento) => ({
                                    label: empreendimento.DS_EMPREENDIMENTO,
                                    value: empreendimento.ID_EMPREENDIMENTO,
                                })
                            )}
                            name="ID_EMPREENDIMENTOS"
                            ref={idEmpreendimentoRef}
                            isClearable
                            isMulti
                            onChange={(e) => {
                                const ids = e.map(
                                    (item) => item?.value
                                ) as number[];
                                listarUnidades({
                                    ID_EMPREENDIMENTO: ids,
                                });
                                setIdEmpreendimento(ids);
                            }}
                            components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                            }}
                            styles={customStyles}
                            placeholder={""}
                            noOptionsMessage={() => "Nenhuma opção"}
                        />
                    </div>
                    <div className="mb-3">
                        <label>Unidade</label>
                        <Select
                            options={unidadesListadas?.map((produto) => ({
                                label: produto.DS_PRODUTO,
                                value: produto.ID_PRODUTO,
                            }))}
                            name="ID_UNIDADE"
                            ref={idUnidadeRef}
                            isClearable
                            isMulti
                            onChange={(e) => {
                                const ids = e.map((item) => item?.value);
                                setIdUnidade(ids);
                            }}
                            components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                            }}
                            styles={customStyles}
                            placeholder={""}
                            noOptionsMessage={() => "Nenhuma opção"}
                        />
                    </div>

                    <div className="mb-3">
                        <UnForm.Input name="ID_CASO" label="Protocolo" />
                    </div>

                    <div className="mb-3">
                        <UnForm.Input name="DS_NOME" label="Cliente" />
                    </div>

                    <div className="mb-3">
                        <UnForm.Input name="NR_TELEFONE" label="Telefone" />
                    </div>

                    <div className="mb-3">
                        <UnForm.Input
                            name="DS_EMAIL"
                            label="Email"
                            type="email"
                        />
                    </div>

                    <UnForm.SubmitButton
                        className="w-100"
                        wrapperClassName="w-100"
                        icon={faFilter}
                        color="dark"
                        outline
                    >
                        Filtrar
                    </UnForm.SubmitButton>
                    <button
                        type="button"
                        onClick={() => {
                            sessionStorage.removeItem(
                                `FILTRO_PESQUISA_SATISFACAO_HELPDESK_${id}`
                            );
                            reset(filtroInicial);
                            limparFiltros();
                        }}
                        className="btn btn-block btn-outline-danger mt-2"
                    >
                        <FontAwesomeIcon icon={faTimes} className="mr-2" />
                        Limpar Filtros
                    </button>
                </UnForm>
            </FormProvider>{" "}
        </StickyToolbar>
    );
}
